import React, { useState, useEffect } from 'react';

const DEFAULT_SVG = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <circle cx="32" cy="32" r="32" fill="#3a3f4b"/>
  <circle cx="32" cy="24" r="10" fill="#6b7280"/>
  <ellipse cx="32" cy="52" rx="18" ry="14" fill="#6b7280"/>
</svg>`)}`;

export default function ProfileImage({ uid, profileImage, size = 32, style }) {
  const [errored, setErrored] = useState(false);

  // Reset error state when profileImage changes (e.g. after upload)
  useEffect(() => {
    setErrored(false);
  }, [profileImage]);

  const baseStyle = {
    width: size,
    height: size,
    borderRadius: '50%',
    objectFit: 'cover',
    flexShrink: 0,
    ...style,
  };

  if (profileImage && !errored) {
    return (
      <img
        src={`/api/users/${uid}/profile-image?v=${encodeURIComponent(profileImage)}`}
        alt=""
        style={baseStyle}
        onError={() => setErrored(true)}
      />
    );
  }

  return <img src={DEFAULT_SVG} alt="" style={baseStyle} />;
}
